// Shared bits for the admin Memberships page and its row editor.
import { typeName } from '../../../utils/sessionTypes';
import { formatDate as ukDate } from '../../../utils/dates';

export const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const DAY_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const STATUS = {
  ACTIVE: { label: 'Active', tone: 'good' },
  PAUSED: { label: 'Paused', tone: 'off' },
  PENDING_PAYMENT: { label: 'Awaiting payment', tone: 'wait' },
  SCHEDULED: { label: 'Starts soon', tone: 'info' },
  CANCELLING: { label: 'Cancelling', tone: 'bad' },
  CANCELLED: { label: 'Cancelled', tone: 'off' },
};

// A live membership with a cancellation date ahead of it (set when British
// Gymnastics membership expires, or read back from Stripe) shows as Cancelling.
export function statusFor(m) {
  const key = m.status !== 'CANCELLED' && m.scheduledCancelAt && new Date(m.scheduledCancelAt) > new Date()
    ? 'CANCELLING'
    : m.status;
  return { key, ...(STATUS[key] || { label: m.status, tone: 'off' }) };
}

export const STATUS_CHIPS = [
  { id: '', label: 'All' },
  { id: 'ACTIVE', label: 'Active' },
  { id: 'PAUSED', label: 'Paused' },
  { id: 'PENDING_PAYMENT', label: 'Awaiting payment' },
  { id: 'SCHEDULED', label: 'Starts soon' },
  { id: 'CANCELLING', label: 'Cancelling' },
  { id: 'CANCELLED', label: 'Cancelled' },
];

export function formatDate(value) {
  return value ? ukDate(value) : '';
}

export function money(pence) {
  return `£${(pence / 100).toFixed(2)}`;
}

export function slotLabel(t) {
  return `${t.startTime} to ${t.endTime} · ${typeName(t)}`;
}

export function parentNames(gymnast) {
  const names = (gymnast.guardians || []).map(g => `${g.firstName} ${g.lastName}`);
  return names.length ? names.join(', ') : 'Adult participant';
}
